import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, FormArray, Validators } from '@angular/forms';

@Component({
    selector: 'dynamic-form-groups-elem',
    template: `
				<div [formGroup]="form" class="{{dataObjectElem.class}}" fxLayout="{{dataObjectElem.layout||'column'}}" *ngIf="evaluate(dataObjectElem.ngIf)">
					<div *ngIf="formArray">
						<div [formArrayName]="formArray">
							<div [formGroupName]="idxArray" fxLayout="{{dataObjectElem.layout||'column'}}">
								<h4 *ngIf="dataObjectElem.label > ''" fxFlex="100%">{{dataObjectElem.label}}</h4>
		          	<div *ngFor="let prop of dataObjectElems" fxLayout="{{prop.layout||'column'}}" fxFlex="{{prop.fxFlex||'none'}}" class="dyn-form-group {{prop.key}} {{prop.class}}">
			              <div [ngSwitch]="prop.type">
											<div *ngSwitchCase="'group'">
													<dynamic-form-groups-elem [dataObjectElem]="prop" [dataObject]="dataObject" [form]="form" [onChange]="onChange"></dynamic-form-groups-elem>
											</div>
											<div *ngSwitchCase="'hidden'">
			                      <input [formControlName]="prop.key"
														(change)="onChange(prop)"
			                      [id]="prop.key" [type]="prop.type">
			                </div>
			                <div *ngSwitchCase="'text'">
			                    <mat-form-field [appearance]="uiSvc ? uiSvc.appearance : 'fill'"style="width: 100%; padding: 0 8px;" [ngClass]="['dyn-form-elem', prop.class||'', prop.key]">
			                        <input matInput placeholder="{{prop.label}}"
															[readonly]="prop.readonly||dataObject.readonly"
			                        [formControlName]="prop.key"
															(change)="onChange(prop)"
			                        [id]="prop.key" [type]="prop.type">
			                    </mat-form-field>
			                </div>
			                <div *ngSwitchCase="'textarea'">
			                    <mat-form-field [appearance]="uiSvc ? uiSvc.appearance : 'fill'"style="width: 100%; padding: 0 8px;" [ngClass]="['dyn-form-elem', prop.class||'', prop.key]">
			                        <textarea matInput placeholder="{{prop.label}}" rows="{{prop.rows||'3'}}" autosize
															[readonly]="prop.readonly||dataObject.readonly"
			                        [formControlName]="prop.key"
															(change)="onChange(prop)"
			                        [id]="prop.key" [type]="prop.type"></textarea>
			                    </mat-form-field>
			                </div>
			                <div *ngSwitchCase="'number'">
			                    <mat-form-field [appearance]="uiSvc ? uiSvc.appearance : 'fill'"style="width: 100%; padding: 0 8px;" [ngClass]="['dyn-form-elem', prop.class||'', prop.key]">
			                        <input matInput placeholder="{{prop.label}}"
															[readonly]="prop.readonly||dataObject.readonly"
			                        [formControlName]="prop.key"
															(change)="onChange(prop)"
			                        [id]="prop.key" [type]="prop.type">
			                    </mat-form-field>
			                </div>
			                <div *ngSwitchCase="'date'">
			                    <mat-form-field [appearance]="uiSvc ? uiSvc.appearance : 'fill'"style="width: 100%; padding: 0 8px;" [ngClass]="['dyn-form-elem', prop.class||'', prop.key]">
			                        <input matInput [matDatepicker]=picker placeholder="{{prop.label}}"
															[readonly]="prop.readonly||dataObject.readonly"
			                        [formControlName]="prop.key"
															(change)="onChange(prop)"
			                        [id]="prop.key">
			                        <mat-datepicker #picker></mat-datepicker>
			                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
			                    </mat-form-field>
			                </div>

											<div *ngSwitchCase="'array'">
													<div *ngFor="let row of prop.value; let i = index">
															<dynamic-form-groups-elem [dataObjectElem]="prop.row" [dataObject]="dataObject" [form]="form" [onChange]="onChange" [formArray]="prop.key" [idxArray]="i"></dynamic-form-groups-elem>
			<!--
															<div *ngFor="let field of prop.rowAsArray">
																		{{field.label}} - {{row[field.key]}} - {{field.key}}
															</div>
			-->
													</div>
			                </div>

											<div *ngSwitchCase="'checkbox'">
			                    <section style="width: 100%; padding: 0 8px;" [ngClass]="['dyn-form-elem', prop.class||'', prop.key]">
			                        <mat-checkbox (change)="onChange(prop)"
			                        [formControlName]="prop.key"
			                        [id]="prop.key">{{prop.label}}</mat-checkbox>
			                    </section>
			                </div>

			                <div *ngSwitchCase="'radio'">
			                <div _ngcontent-c20="" style="height: 20px;" style="width: 100%; padding: 0 8px;" [ngClass]="['dyn-form-elem', prop.class||'', prop.key]">
			                  <label _ngcontent-c20="" style="transform: translateY(-1.28125em) scale(0.75) perspective(100px) translateZ(0.001px);-ms-transform: translateY(-1.28125em) scale(0.75);width: 133.33333333%;margin: 14px 0 0 -66px;font-weight: 100;color: #666;">
			                        {{prop.label}}
			                      </label>
			                    </div>
			                    <mat-radio-group [formControlName]="prop.key" [name]="prop.key" fxLayout="column">
			                      <mat-radio-button [value]="option.value" *ngFor="let option of prop.options" (change)="onChange(prop)">
			                        {{option.label}}
			                      </mat-radio-button>
			                    </mat-radio-group>
			                </div>

			                <div *ngSwitchCase="'select'">
												<mat-form-field [appearance]="uiSvc ? uiSvc.appearance : 'fill'"style="width: 100%; padding: 0 8px;" [ngClass]="['dyn-form-elem', prop.class||'', prop.key]">
													<mat-select [formControlName]="prop.key" placeholder="{{prop.label}}" (change)="onChange(prop)" *ngIf="!prop.readony&&!dataObject.readonly">
														<mat-option *ngFor="let option of prop.options" [value]="option.value">
															{{ option.label }}
														</mat-option>
													</mat-select>
													<input matInput placeholder="{{prop.label}}"
													[readonly]="prop.readonly||dataObject.readonly"
													[formControlName]="prop.key"
													(change)="onChange(prop)"
													[id]="prop.key" [type]="prop.type" *ngIf="prop.readony||dataObject.readonly">
												</mat-form-field>
			                </div>


											<div *ngSwitchCase="'tag'">
												<div [ngSwitch]="prop.tag">
													<div *ngSwitchCase="'h2'">
														<h2 [ngClass]="[prop.class||'']">{{prop.content}}</h2>
													</div>
													<div *ngSwitchCase="'h3'">
														<h3 [ngClass]="[prop.class||'']">{{prop.content}}</h3>
													</div>
													<div *ngSwitchCase="'h4'">
														<h4 [ngClass]="[prop.class||'']">{{prop.content}}</h4>
													</div>
													<div *ngSwitchCase="'p'">
														<p [ngClass]="[prop.class||'']">{{prop.content}}</p>
													</div>
													<div *ngSwitchCase="'div'">
														<div [ngClass]="[prop.class||'']">{{prop.content}}</div>
													</div>
												</div>
											</div>
		              	</div>
	              	</div>
	              </div>
          	</div>
          </div>
					<!--

							NO ARRAY

					-->
					<div *ngIf="!formArray" fxLayout="{{dataObjectElem.layout||'column'}}">
						<h4 *ngIf="dataObjectElem.label > ''" fxFlex="100%">{{dataObjectElem.label}}</h4>
						<div *ngFor="let prop of dataObjectElems" fxLayout="{{prop.layout||'column'}}" fxFlex="{{prop.fxFlex||'none'}}" class="dyn-form-group {{prop.key}} {{prop.class}}">
	              <div [ngSwitch]="prop.type">
									<div *ngSwitchCase="'group'">
											<dynamic-form-groups-elem [dataObjectElem]="prop" [dataObject]="dataObject" [form]="form" [onChange]="onChange"></dynamic-form-groups-elem>
									</div>
									<div *ngSwitchCase="'hidden'">
	                      <input [formControlName]="prop.key"
												(change)="onChange(prop)"
	                      [id]="prop.key" [type]="prop.type">
	                </div>
	                <div *ngSwitchCase="'text'">
	                    <mat-form-field [appearance]="uiSvc ? uiSvc.appearance : 'fill'"style="width: 100%; padding: 0 8px;" [ngClass]="['dyn-form-elem', prop.class||'', prop.key]">
	                        <input matInput placeholder="{{prop.label}}"
													[readonly]="prop.readonly||dataObject.readonly"
	                        [formControlName]="prop.key"
													(change)="onChange(prop)"
	                        [id]="prop.key" [type]="prop.type">
	                    </mat-form-field>
	                </div>
	                <div *ngSwitchCase="'textarea'">
	                    <mat-form-field [appearance]="uiSvc ? uiSvc.appearance : 'fill'"style="width: 100%; padding: 0 8px;" [ngClass]="['dyn-form-elem', prop.class||'', prop.key]">
	                        <textarea matInput placeholder="{{prop.label}}" rows="{{prop.rows||'3'}}" autosize
													[readonly]="prop.readonly||dataObject.readonly"
	                        [formControlName]="prop.key"
													(change)="onChange(prop)"
	                        [id]="prop.key" [type]="prop.type"></textarea>
	                    </mat-form-field>
	                </div>
	                <div *ngSwitchCase="'number'">
	                    <mat-form-field [appearance]="uiSvc ? uiSvc.appearance : 'fill'"style="width: 100%; padding: 0 8px;" [ngClass]="['dyn-form-elem', prop.class||'', prop.key]">
	                        <input matInput placeholder="{{prop.label}}"
													[readonly]="prop.readonly||dataObject.readonly"
	                        [formControlName]="prop.key"
													(change)="onChange(prop)"
	                        [id]="prop.key" [type]="prop.type">
	                    </mat-form-field>
	                </div>
	                <div *ngSwitchCase="'date'">
	                    <mat-form-field [appearance]="uiSvc ? uiSvc.appearance : 'fill'"style="width: 100%; padding: 0 8px;" [ngClass]="['dyn-form-elem', prop.class||'', prop.key]">
	                        <input matInput [matDatepicker]=picker placeholder="{{prop.label}}"
													[readonly]="prop.readonly||dataObject.readonly"
	                        [formControlName]="prop.key"
													(change)="onChange(prop)"
	                        [id]="prop.key">
	                        <mat-datepicker #picker></mat-datepicker>
	                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
	                    </mat-form-field>
	                </div>

									<div *ngSwitchCase="'array'">
											<div fxLayout="{{prop.layout||'column'}}">
													<h4 *ngIf="prop.label > ''">{{prop.label}}</h4>
													<div *ngFor="let row of prop.value; let i = index" [formArrayName]="prop.key">
															<dynamic-form-groups-elem [dataObjectElem]="prop.row" [dataObject]="dataObject" [form]="form" [onChange]="onChange" [formArray]="prop.key" [idxArray]="i"></dynamic-form-groups-elem>
			<!--
															<div *ngFor="let field of prop.rowAsArray">
																		{{field.label}} - {{row[field.key]}} - {{field.key}}
															</div>
			-->
													</div>
											</div>
	                </div>

									<div *ngSwitchCase="'checkbox'">
	                    <section style="width: 100%; padding: 0 8px;" [ngClass]="['dyn-form-elem', prop.class||'', prop.key]">
	                        <mat-checkbox (change)="onChange(prop)"
	                        [formControlName]="prop.key"
	                        [id]="prop.key">{{prop.label}}</mat-checkbox>
	                    </section>
	                </div>

	                <div *ngSwitchCase="'radio'">
	                <div _ngcontent-c20="" style="height: 20px;" style="width: 100%; padding: 0 8px;" [ngClass]="['dyn-form-elem', prop.class||'', prop.key]">
	                  <label _ngcontent-c20="" style="transform: translateY(-1.28125em) scale(0.75) perspective(100px) translateZ(0.001px);-ms-transform: translateY(-1.28125em) scale(0.75);width: 133.33333333%;margin: 14px 0 0 -66px;font-weight: 100;color: #666;">
	                        {{prop.label}}
	                      </label>
	                    </div>
	                    <mat-radio-group [formControlName]="prop.key" [name]="prop.key" fxLayout="column">
	                      <mat-radio-button [value]="option.value" *ngFor="let option of prop.options" (change)="onChange(prop)">
	                        {{option.label}}
	                      </mat-radio-button>
	                    </mat-radio-group>
	                </div>

	                <div *ngSwitchCase="'select'">
										<mat-form-field [appearance]="uiSvc ? uiSvc.appearance : 'fill'"style="width: 100%; padding: 0 8px;" [ngClass]="['dyn-form-elem', prop.class||'', prop.key]">
											<mat-select [formControlName]="prop.key" placeholder="{{prop.label}}" (change)="onChange(prop)" *ngIf="!prop.readony&&!dataObject.readonly">
												<mat-option *ngFor="let option of prop.options" [value]="option.value">
													{{ option.label }}
												</mat-option>
											</mat-select>
											<input matInput placeholder="{{prop.label}}"
											[readonly]="prop.readonly||dataObject.readonly"
											[formControlName]="prop.key"
											(change)="onChange(prop)"
											[id]="prop.key" [type]="prop.type" *ngIf="prop.readony||dataObject.readonly">
										</mat-form-field>
	                </div>


									<div *ngSwitchCase="'tag'">
										<div [ngSwitch]="prop.tag">
											<div *ngSwitchCase="'h2'">
												<h2 [ngClass]="[prop.class||'']">{{prop.content}}</h2>
											</div>
											<div *ngSwitchCase="'h3'">
												<h3 [ngClass]="[prop.class||'']">{{prop.content}}</h3>
											</div>
											<div *ngSwitchCase="'h4'">
												<h4 [ngClass]="[prop.class||'']">{{prop.content}}</h4>
											</div>
											<div *ngSwitchCase="'p'">
												<p [ngClass]="[prop.class||'']">{{prop.content}}</p>
											</div>
											<div *ngSwitchCase="'div'">
												<div [ngClass]="[prop.class||'']">{{prop.content}}</div>
											</div>
										</div>
									</div>
	              </div>
              </div>
          </div>
        </div>
  `,
    styles: [
        `
        .error { color: red; }
        `
    ],
    standalone: false
})
export class DynamicFormGroupsElemComponent implements OnInit {
  @Input() dataObjectElem;
  @Input() dataObject;
  @Input() formArray = false;
  @Input() idxArray;
	@Input() form: UntypedFormGroup;
	@Input() onChange;
	dataObjectElems: any[];

  constructor(
			private formBuilder: UntypedFormBuilder
	) {

	}

  ngOnInit() {
		// console.log(this.dataObject, Object.keys(this.dataObjectElem.fields));
    // remap the API to be suitable for iterating over it
		const formGroup = {};
		let tempArray = [],
				tempGroup: any,
				newArray: any,
				i: number,
				l: number;

		/**
		 * Si hay grupos de detalle (arrays) preparamos los datos
		 */
		for (let prop in this.dataObjectElem.fields) {
				if (this.dataObjectElem.fields[prop].type === 'array') {
						this.dataObjectElem.fields[prop].rowAsArray = Object.keys(this.dataObjectElem.fields[prop].row.fields)
							.map(prop2 => {
								return Object.assign({}, {key: prop2}, this.dataObjectElem.fields[prop].row.fields[prop2]);
							});
				}
		}

		for (let prop in this.dataObjectElem.fields) {
				// console.log(prop, this.dataObjectElem.fields[prop]);
				if (this.dataObjectElem.fields[prop].type === 'array') {
						/**
						 * Nos encontramos con un array; preparamos el formulario para insertar los grupos de controles.
						 */
						this.dataObjectElem.fields[prop].rows = [];
						tempArray = [];
						for (i=0,l=this.dataObjectElem.fields[prop].value.length;i<l;i++) {
								tempGroup = {};
								for (let prop2 in this.dataObjectElem.fields[prop].row.fields) {
										tempGroup[prop2] = this.dataObjectElem.fields[prop].value[i][prop2];
								}
								tempArray.push(this.formBuilder.group(tempGroup));
						}
						// console.log(tempArray);
						this.form.addControl(prop, this.formBuilder.array(tempArray));
				} else {
						this.form.addControl(prop, new UntypedFormControl(this.dataObjectElem.fields[prop].value || '', this.mapValidators(this.dataObjectElem.fields[prop].validation)));
				}
		}

		this.dataObjectElems =
      Object.keys(this.dataObjectElem.fields)
        .map(prop => {
          return Object.assign({}, { key: prop} , this.dataObjectElem.fields[prop]);
        });

		// console.log(this.dataObjectElems, this.dataObjectElem);
  }

	evaluate(expression):boolean {
      let ret = true;
      if (typeof expression !== 'undefined' && expression !== null) {
          // ret = eval(expression);
          ret = (0, eval)(expression);
      }
      return ret;
  }

	private mapValidators(validators) {
    const formValidators = [];

    if(validators) {
      for(const validation of Object.keys(validators)) {
        if(validation === 'required') {
          formValidators.push(Validators.required);
        } else if(validation === 'min') {
          formValidators.push(Validators.min(validators[validation]));
        }
      }
    }

    return formValidators;
  }

}
